import { render, staticRenderFns } from "./ticket-history-item.vue?vue&type=template&id=b4314314&scoped=true&"
import script from "./ticket-history-item.vue?vue&type=script&lang=js&"
export * from "./ticket-history-item.vue?vue&type=script&lang=js&"
import style0 from "./ticket-history-item.vue?vue&type=style&index=0&id=b4314314&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4314314",
  null
  
)

export default component.exports